import graphql__534b0722596298b9b7c2 from "./__generated__/PageSections_page.graphql.js";import { createFragmentContainer } from "react-relay";
import { graphql } from "react-relay";
import classNames from "classnames";

import PageSection from "./";
import AnchorTarget from "../Utils/AnchorTarget";

function PageSections(props) {
  const { edges } = props.page.sections;

  if (!edges.length) return null;

  const className = classNames(["sections-list", props.className]);

  return (
    <div className={className}>
      {edges.map((edge, index) => (
        <div
          key={edge.node.id}
          className={classNames("page-section-wrapper", {
            "margin-bottom-xs": index < edges.length - 1
          })}
        >
          <AnchorTarget id={edge.node.domId} />

          <PageSection pageSection={edge.node} />
        </div>
      ))}
    </div>
  );
}

export default createFragmentContainer(PageSections, {
  page: graphql__534b0722596298b9b7c2
});
